export default __webpack_public_path__ + "static/media/header-container-orange.250acd4e.png";